module.exports = __webpack_public_path__ + "static/img/day1.62219a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day1.jpg
// module id = MJoL
// module chunks = 0